/**
 * Feature pricing slice pieces — the per-feature-category price rows shown on
 * the feature pricing admin table.
 *
 * Contains:
 * - featurePricingInitialState — adapter state + table view substate
 * - addFeaturePricingCases — load-list / delete extra reducers
 * - feature pricing selectors
 */
import { createSelector } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import { deleteFeaturePricing, loadFeaturePricing } from '@sophocles/features/billing/api';
import { FeaturePricingSchema } from '@sophocles/features/billing/schema';
import { featurePricingAdapter } from '@sophocles/features/billing/slices/adapters';

export const featurePricingInitialState = featurePricingAdapter.getInitialState({
  view: {
    search: null,
    page: 0,
    order: 'asc',
    orderBy: 'id',
  },
});

export const addFeaturePricingCases = builder => {
  builder
    .addCase(loadFeaturePricing.fulfilled, (state, action) => {
      if (action.payload.results.length === 0) {
        return;
      }
      const normalized = normalize(action.payload.results, [FeaturePricingSchema]);
      featurePricingAdapter.upsertMany(state.featurePricing, normalized.entities.featurePricing);
    })
    .addCase(deleteFeaturePricing.fulfilled, (state, action) => {
      featurePricingAdapter.removeOne(state.featurePricing, action.payload);
    });
};

export const selectFeaturePricingEntities = state => {
  return state.billing.featurePricing;
};
export const { selectById: selectFeaturePricingById } =
  featurePricingAdapter.getSelectors(selectFeaturePricingEntities);
export const selectFeaturePricing = id => state => selectFeaturePricingById(state, id);
export const selectFeaturePricingViewProperties = createSelector(selectFeaturePricingEntities, state => state.view);
